module.exports = __webpack_public_path__ + "static/media/manhattan-light-black-cord.a0b54cf2.jpg";